// import React, { useState, useContext, useEffect, useRef } from "react";
// import { GlobalContext } from "../../../App";
// import L from "leaflet";

// export default function InputWms() {
//   const [show, setshow] = useState(false);
//   const { vis } = useContext(GlobalContext);
//   const { Canvas, layerControls, map } = useContext(GlobalContext);
//   const toolvisRef = useRef(null);
//   const [wmsUrl, setWmsUrl] = useState("");
//   const [layerName, setLayerName] = useState("");

//   let layer;

//   function AddWMTSLayer() {
//     if (layer) {
//       layer.remove();
//     }
//     const cleanedWmsUrl = wmsUrl.includes("Format=image/jpeg")
//   ? wmsUrl.replace("Format=image/jpeg", "Format=image%2Fpng")
//   : wmsUrl;

//   console.log("cleanedWmsUrl", cleanedWmsUrl);

//     layer = L.tileLayer(cleanedWmsUrl, {
//       transparent: true,
//       format: 'image/png',
//       maxZoom: 20,
//       zIndex: 1000,
//     });
//    console.log("layer", layer);

//     layerControls.addOverlay(
//       layer,
//       layerName,
//       false,
//       false,
//       false
//     );

//     layer.addTo(map);   
// }

//   // function AddGeoJsonLayerFromURL(url) {
//   //     if (!url) {
//   //       alert("Please enter a valid GeoJSON URL.");
//   //       return;
//   //     }

//   //     fetch(url)
//   //       .then((res) => res.json())
//   //       .then((geojsonData) => {
//   //         const layer = L.geoJSON(geojsonData, {
//   //           onEachFeature: function (feature, layer) {
//   //             if (feature.properties) {
//   //               const popupContent = Object.entries(feature.properties)
//   //                 .map(([key, val]) => `<b>${key}</b>: ${val}`)
//   //                 .join("<br>");
//   //               layer.bindPopup(popupContent);
//   //             }
//   //           },
//   //           style: {
//   //             color: "red",
//   //             weight: 2
//   //           }
//   //         });

//   //         layerControls.addOverlay(layer, "WFS Layer", true, true, true);
//   //         layer.addTo(map);
//   //         map.fitBounds(layer.getBounds());
//   //         map.setZoom(13);
//   //         setWmsUrl("");
//   //       })
//   //       .catch((err) => {
//   //         console.error("Failed to load GeoJSON:", err);
//   //         alert("Failed to load GeoJSON layer.");
//   //       });
//   //   }

//   return (
//     <>
//       <div
//         style={{ position: vis ? "absolute" : "relative" }}
//         className="toolscont"
//       >
//         <button
//           title="Upload WMS Layer"
//           className="btn text-white"
//           id="upload"
//           onClick={() => setshow((prevshow) => !prevshow)}
//           style={{
//             zIndex: "1000",
//             fontSize: "15px",
//             backgroundColor: "black",
//             padding: "2px 2px",
//             width: "40px",
//             height: "40px",
//             borderRadius: "50%",
//             border: "none",
//           }}
//         >
//           <i className="fa-solid fa-link"></i>
//         </button>
//         {show ? (
//           <div
//             ref={toolvisRef}
//             className="toolsvis"
//             id="toolvis"
//             style={{ width: "230px" }}
//           >
//             <span
//               onClick={() => setshow(false)}
//               className="toolclose text-danger"
//             >
//               &times;
//             </span>

//             <label
//               className="text-white"
//               htmlFor="fileInput"
//               style={{ marginLeft: "3%" }}
//             >
//               Enter WMS Link :{" "}
//             </label>
//             <div>
//               <input
//                 className="form-control custom-select mt-1"
//                 style={{ marginLeft: "1%" }}
//                 value={wmsUrl}
//                 onChange={(e) => setWmsUrl(e.target.value)}
//                 placeholder="Enter full WMS link"
//               />
//               <input
//                 className="form-control custom-select mt-1"
//                 style={{ marginLeft: "1%" }}
//                 value={layerName}
//                 onChange={(e) => setLayerName(e.target.value)}
//                 placeholder="Enter layer name"
//               />
//               <button
//                 className="btn btn-primary border-0 mt-3 mb-3"
//                 style={{
//                   width: "97%",
//                   height: "35px",
//                   fontSize: "13px",
//                   marginLeft: "2%",
//                 }}
//                 onClick={() => AddWMTSLayer()}
//               >
//                 Add WMS Layer
//               </button>
//             </div>
//           </div>
//         ) : null}
//       </div>
//     </>
//   );
// }

import { useState, useContext, useRef, useEffect } from "react";
import L from "leaflet";
import { GlobalContext } from "../../../App";
import { ToastContainer, toast } from "react-toastify";


export default function InputWms() {
  const [show, setshow] = useState(false);
  const { vis, Canvas, layerControls, map } = useContext(GlobalContext);
  const toolvisRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [wmsUrl, setWmsUrl] = useState("");
  const [layerList, setLayerList] = useState([]);
  const [selectedLayer, setSelectedLayer] = useState("");

  let layer;

  useEffect(() => {
    if (wmsUrl) {
      fetchCapabilities(wmsUrl);
    }
  }, [wmsUrl]);

  // async function fetchCapabilities(url) {
  //   try {
  //     const capUrl = url.includes("?")
  //       ? `${url}&service=WMS&request=GetCapabilities`
  //       : `${url}?service=WMS&request=GetCapabilities`;

  //     const res = await fetch(capUrl);
  //     const text = await res.text();

  //     const parser = new DOMParser();
  //     const xml = parser.parseFromString(text, "text/xml");

  //     const layers = Array.from(xml.getElementsByTagName("Layer"))
  //       .filter((layer) => layer.getElementsByTagName("Name")[0])
  //       .map((layer) => {
  //         const name = layer.getElementsByTagName("Name")[0].textContent;
  //         const titleTag = layer.getElementsByTagName("Title")[0];
  //         const title = titleTag ? titleTag.textContent : name;
  //         return { name, title };
  //       });

  //     setLayerList(layers);
  //   } catch (error) {
  //     console.error("Error fetching WMS Capabilities:", error);
  //   }
  // }


  function getBaseWmsUrl(url) {
    const [base] = url.split("?");
    return base;
  }

  // async function fetchCapabilities(url) {
  //   try {
  //     const baseUrl = getBaseWmsUrl(url);
  //     const capUrl = `${baseUrl}?service=WMS&request=GetCapabilities`;

  //     const res = await fetch(capUrl);
  //     const text = await res.text();

  //     const parser = new DOMParser();
  //     const xml = parser.parseFromString(text, "text/xml");

  //     // const layers = Array.from(xml.getElementsByTagName("Layer"))
  //     //   .filter((layer) => layer.getElementsByTagName("Name")[0])
  //     //   .map((layer) => {
  //     //     const name = layer.getElementsByTagName("Name")[0].textContent;
  //     //     const titleTag = layer.getElementsByTagName("Title")[0];
  //     //     const title = titleTag ? titleTag.textContent : name;
  //     //     return { name, title };
  //     //   });

  //     // setLayerList(layers);

  //     const layers = Array.from(xml.getElementsByTagName("Layer"))
  //       .filter((layer) => layer.getElementsByTagName("Name")[0])
  //       .map((layer) => {
  //         const name = layer.getElementsByTagName("Name")[0].textContent;
  //         const titleTag = layer.getElementsByTagName("Title")[0];
  //         const title = titleTag ? titleTag.textContent : name;

  //         // Get EX_GeographicBoundingBox or LatLonBoundingBox
  //         const bboxTag = layer.getElementsByTagName("EX_GeographicBoundingBox")[0] ||
  //           layer.getElementsByTagName("LatLonBoundingBox")[0];

  //         let bounds = null;

  //         if (bboxTag) {
  //           const west = parseFloat(bboxTag.getElementsByTagName("westBoundLongitude")[0]?.textContent || bboxTag.getAttribute("minx"));
  //           const east = parseFloat(bboxTag.getElementsByTagName("eastBoundLongitude")[0]?.textContent || bboxTag.getAttribute("maxx"));
  //           const south = parseFloat(bboxTag.getElementsByTagName("southBoundLatitude")[0]?.textContent || bboxTag.getAttribute("miny"));
  //           const north = parseFloat(bboxTag.getElementsByTagName("northBoundLatitude")[0]?.textContent || bboxTag.getAttribute("maxy"));
  //           bounds = [[south, west], [north, east]];
  //         }

  //         return { name, title, bounds };
  //       });

  //     setLayerList(layers);

  //     console.log("layers", layers);
  //   } catch (error) {
  //     alert("Error fetching WMS Capabilities:", error);
  //   }
  // }

  async function fetchCapabilities(url) {
    try {
      const baseUrl = getBaseWmsUrl(url);
      const capUrl = `${baseUrl}?service=WMS&request=GetCapabilities`;
  
      const res = await fetch(capUrl);
      const text = await res.text();
  
      const parser = new DOMParser();
      const xml = parser.parseFromString(text, "text/xml");
  
      const layers = Array.from(xml.getElementsByTagName("Layer"))
        .filter((layer) => {
          const nameTag = layer.getElementsByTagName("Name")[0];
          return nameTag && nameTag.textContent !== "watershed"; // Exclude "watershed"
        })
        .map((layer) => {
          const name = layer.getElementsByTagName("Name")[0].textContent;
          const titleTag = layer.getElementsByTagName("Title")[0];
          const title = titleTag ? titleTag.textContent : name;
  
          const bboxTag = layer.getElementsByTagName("EX_GeographicBoundingBox")[0] ||
                          layer.getElementsByTagName("LatLonBoundingBox")[0];
  
          let bounds = null;
  
          if (bboxTag) {
            const west = parseFloat(bboxTag.getElementsByTagName("westBoundLongitude")[0]?.textContent || bboxTag.getAttribute("minx"));
            const east = parseFloat(bboxTag.getElementsByTagName("eastBoundLongitude")[0]?.textContent || bboxTag.getAttribute("maxx"));
            const south = parseFloat(bboxTag.getElementsByTagName("southBoundLatitude")[0]?.textContent || bboxTag.getAttribute("miny"));
            const north = parseFloat(bboxTag.getElementsByTagName("northBoundLatitude")[0]?.textContent || bboxTag.getAttribute("maxy"));
            bounds = [[south, west], [north, east]];
          }
  
          return { name, title, bounds };
        });
  
      setLayerList(layers);
      console.log("layers", layers);
    } catch (error) {
      alert("Error fetching WMS Capabilities");
      console.error("WMS Capabilities Error:", error);
    }
  }
  

  // function AddWMSLayer() {
  //   setLoader(true);

  //   if (layer) {
  //     layer.remove();
  //   }

  //   if (!wmsUrl || !selectedLayer) {
  //     setLoader(false);
  //     alert("WMS URL and Layer must be selected");
  //     return;
  //   }

  //   const baseUrl = getBaseWmsUrl(wmsUrl);

  //   layer = L.tileLayer.wms(baseUrl, {
  //     layers: selectedLayer,
  //     format: "image/png",
  //     transparent: true,
  //     maxZoom: 20,
  //     zIndex: 1000,
  //   });

  //   layerControls.addOverlay(layer, selectedLayer, false, false, false);
  //   layer.addTo(map);
  //   alert("Failed to add WMS layer");
  //   const selected = layerList.find((l) => l.name === selectedLayer);
  //   if (selected?.bounds) {
  //     map.fitBounds(selected.bounds);
  //   }

  //   setLoader(false);
  //   setshow(false);
  // }

  function AddWMSLayer() {
    setLoader(true)
    if (layer) {
      layer.remove();
    }

    if (!wmsUrl || !selectedLayer) return;

    const cleanedWmsUrl = wmsUrl.includes("Format=image/jpeg")
      ? wmsUrl.replace("Format=image/jpeg", "Format=image%2Fpng")
      : wmsUrl;

    layer = L.tileLayer.wms(cleanedWmsUrl, {
      layers: selectedLayer,
      format: "image/png",
      transparent: true,
      maxZoom: 20,
      zIndex: 1000,
    });

    layerControls.addOverlay(layer, selectedLayer, false, false, false);
    layer.addTo(map);

    const selected = layerList.find(l => l.name === selectedLayer);
    if (selected?.bounds) {
      map.fitBounds(selected.bounds);
    }

    setLoader(false);

  }

return (
  <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">

    {/* ── Trigger Button ── */}
    <button
      title="Upload WMS Layer"
      className="btn text-white"
      id="upload"
      onClick={() => setshow((prev) => !prev)}
      style={{
        zIndex: "1000", fontSize: "15px", backgroundColor: "black",
        padding: "2px", width: "40px", height: "40px",
        borderRadius: "50%", border: "none",
      }}
    >
      <i className="fa-solid fa-link" />
    </button>

    {show && (
      <div
        ref={toolvisRef}
        className="toolsvis"
        id="toolvis"
        style={{ display: "flex", flexDirection: "column", width: "250px", padding: "10px 12px" }}
      >
        {/* ── Header ── */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          paddingBottom: "8px", marginBottom: "10px",
          borderBottom: "1px solid rgba(255,255,255,0.12)"
        }}>
          <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
            <i className="fa-solid fa-link" style={{ marginRight: "6px", fontSize: "11px" }} />
            Upload WMS Layer
          </span>
          <span
            onClick={() => setshow(false)}
            style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
          >
            &times;
          </span>
        </div>

        {/* ── Loader ── */}
        {loader && (
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <div className="lds-dual-ring">
              <i className="fa-solid fa-globe" />
            </div>
          </div>
        )}

        {/* ── Inputs ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

          {/* WMS URL */}
          <div>
            <label style={{ fontSize: "11px", color: "#aaa", marginBottom: "3px", display: "block" }}>
              WMS Link
            </label>
            <input
              className="form-control"
              style={{
                fontSize: "12px", height: "30px",
                backgroundColor: "transparent",
                border: "1px solid rgba(255,255,255,0.25)",
                color: "white", borderRadius: "4px",
              }}
              value={wmsUrl}
              onChange={(e) => setWmsUrl(e.target.value)}
              placeholder="https://example.com/wms"
            />
          </div>

          {/* Layer Select */}
          {layerList.length > 0 && (
            <div>
              <label style={{ fontSize: "11px", color: "#aaa", marginBottom: "3px", display: "block" }}>
                Select Layer
              </label>
              <select
                className="form-select text-white"
                style={{
                  fontSize: "12px", padding: "4px 6px",
                  backgroundColor: "black",
                  border: "1px solid rgba(255,255,255,0.25)",
                  color: "white", borderRadius: "4px",
                }}
                value={selectedLayer}
                onChange={(e) => setSelectedLayer(e.target.value)}
              >
                <option value="">-- Select --</option>
                {layerList.map((l) => (
                  <option key={l.name} value={l.name}>{l.title}</option>
                ))}
              </select>
            </div>
          )}

          {/* Add Button */}
          <button
            className="btn btn-primary border-0"
            style={{ width: "100%", height: "32px", fontSize: "12px", marginTop: "2px" }}
            onClick={AddWMSLayer}
          >
            Add WMS Layer
          </button>

        </div>
      </div>
    )}
  </div>
);
}
